function pluralize(count, singular, plural) {
  if (count === 1) return singular
  return plural || singular + 's'
}

// Legacy syntax so that the server code can require it
module.exports = pluralize
